import getPageNodes from './get-page-nodes';
import getMapValues from '../../../lib/get-map-values';

const getPageNodesValues = state => getMapValues(getPageNodes(state));

export default getPageNodesValues;
